import React from "react"
import { Box, Text } from "@chakra-ui/react"
import { asNumber } from "utilities/strings"

const VerticalStat = ({ label, value }: { label: string, value: number }) => (
  <Box>
    <Text fontSize="2xl" fontWeight="semibold" lineHeight="short">{asNumber(value)}</Text>
    <Text color="gray.600">{label}</Text>
  </Box>
)

export default VerticalStat
